import useFetch from "../../../../hooks/useFetch"
import {SelectInput, Spinner, Icon} from "asocomponents"
import PrestadorServices from "../../../../../modules/Prestador/application/PrestadorServices"

function SelectPrestador({onChange, width, todos, valor, idLetrado}) {
  const prestadoresService = new PrestadorServices()
  const { isLoading, data, isFailed } = useFetch(
    prestadoresService,
    "getPrestadores",
    idLetrado
  )

  if (isLoading) {
    return <Spinner color="red" size="10" />
  }

  if (isFailed) {
    return <Icon type="error"/>
  }

  return (
    <div>
      <SelectInput options={data} placeholder="Seleccionar" onChange={onChange} width={width} todos={todos && true} defaultValue={valor || "-2"}></SelectInput>
    </div>
  )
}

export default SelectPrestador

